module.exports = __webpack_public_path__ + "static/media/cabinetImg2.8a5bebe3.png";